import React, { Suspense, useState } from "react";
import { useLocation } from "react-router";
import useIsUserLoggedIn from "../../CustomHooks/useIsUserLoggedIn";
import { LOGIN_CTA_CLICKED } from "../../GATracker3.0/constants";
import { eventTracker } from "../../GATracker3.0/eventTracker";
import { isMobile } from "../../helperFunc";
import { heartIcon } from "../../icon_assets";
import { heartIcon3 } from "../../icon_assets";
import Login from "../../Login/Login";
import style from "./style.module.css";
const BookMarkComponent = (props) => {
  const {
    bookMarked,
    className,
    borderCSS,
    imageHeightWidth,
    onClick,
    handleOnClickForNonLogin = false,
  } = props;
  const [show, setShow] = useState(false);
  const [isUserLoggedIn] = useIsUserLoggedIn();
  const location = useLocation();

  const bookMarkClicked = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isUserLoggedIn) {
      onClick(e);
    } else {
      eventTracker("event", LOGIN_CTA_CLICKED, {
        pagename: location.pathname === "/" ? "homepage" : location.pathname,
      });
      setShow(true);
    }
  };
  return (
    <>
      {show && (
        <Suspense fallback={<></>}>
          <Login show={show} setShow={setShow} callBackFunction={onClick} />
        </Suspense>
      )}{" "}
      <div
        className={`${className} ${
          borderCSS ? borderCSS : style["borderCSS"]
        } backgroundWhite  line-height12 ${!isMobile && "cursorPointer"} `}
        onClick={handleOnClickForNonLogin ? onClick : bookMarkClicked}
      >
        <img
          className={
            imageHeightWidth ? imageHeightWidth : style["heartHeightWidth"]
          }
          alt=""
          src={bookMarked ? heartIcon3 : heartIcon}
        />
      </div>
    </>
  );
};
export default BookMarkComponent;
